import React, { memo } from 'react';
import ReactMarkdown from 'react-markdown';
import '../css/Chat.css';  // Custom styles for the chat component
import { Spinner } from 'react-bootstrap';

const Message = memo(({ msg }) => (
  <div className={`chat-message ${msg.sender}`}>
    <ReactMarkdown
      components={{
        img: ({ node, ...props }) => <CustomImage {...props} />,
        a: ({ node, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">
            {props.children}
          </a>
        )
      }}
    >
      {msg.text}
    </ReactMarkdown>
  </div>
));

const LastMessage = ({ msg, loading }) => (
    <div className={`chat-message ${msg.sender}`}>
      <ReactMarkdown
        components={{
          img: ({ node, ...props }) => <CustomImage {...props} />,
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
          )
        }}
      >
        {msg.text}
      </ReactMarkdown>
           {/* Conditionally show spinner when loading */}
           {loading && msg.sender == 'assistant' && (
            <div className="loading-spinner d-flex align-items-center">
            <Spinner animation="grow" role="status" size="sm" className="me-2" />
            <span className="text-muted">Bitte warten, es könnte einige Sekunden dauern...</span>
            </div>
           )}
    </div>
  );





const CustomImage = ({ src, alt }) => {
    return <img src={src} alt={alt} style={{ maxWidth: '100%', height: 'auto' }} />;
  };

  function LinkRenderer(props: any) {
    return (
      <a href={props.href} target="_blank" rel="noreferrer">
        {props.children}
      </a>
    );
  }

const ReactMarkdownCustom= ({ content }) => {
    return (
      <ReactMarkdown
        components={{
          a: ({ node, ...props }) => (
            <a {...props} target="_blank" rel="noopener noreferrer">
              {props.children}
            </a>
          ),
          img: ({ node, ...props }) => <CustomImage {...props} />,
        }}
      >
        {content}
      </ReactMarkdown>
    );
  };

  const ChatBody = ({ messages, chatBodyRef, loading }) => {

    // Create a system message that will always appear as the first message
    const firstMessage = {
      sender: 'assistant', // or 'bot'
      text: 'Hallo! Ich bin dein Geschenk-Bot. Erzähl mir, für wen du ein Geschenk suchst und ich mache dir Vorschläge! 🎁',
    };

    return (
      <div className="chat-body" ref={chatBodyRef}>
          {[firstMessage, ...messages].map((msg, index) => {
            const key = msg.id || msg.timestamp || index; // Ensure a unique key, fallback to index
            if (index === 1) {
              // Handle the first message
              return <LastMessage key={key} msg={msg} />;
            } else if (index === messages.length ) {
              // Handle the last message
              return <LastMessage key={key} msg={msg} loading={loading} />;
            } else {
              // Handle all other messages
              return <Message key={key} msg={msg} />;
            }
          })
        }
      </div>
    );
  };
/*
const ChatBody = ({ messages, chatBodyRef, loading }) => {
  return (
    <div className="chat-body" ref={chatBodyRef}>
      {messages.length === 0 ? (
        <p className="text-muted">Erzähle mir für wen du ein Geschenk suchst?</p>
      ) : (
        messages.map((msg, index) => {
            // Check if it's the last message
            if (index === 0) {
              return <LastMessage key={msg.id || msg.timestamp} msg={msg} />;
            }
            else if (index === messages.length - 1) {
              return <LastMessage key={msg.id || msg.timestamp} msg={msg} loading={loading} />;
            } else {
              return <Message key={msg.id || msg.timestamp} msg={msg} />;
            }
          })
        //messages.map((msg) => (
            //<Message key={msg.id || msg.timestamp} msg={msg} />
          //))
      )}
    </div>
  );
};
*/

export default ChatBody;